import { connect } from 'react-redux';
import { getIsFavorite } from 'store/reducers/favorites';
import { favoritePodcastToggle } from 'actions/favoritePodcast-actions';
import { favoriteStationToggle } from 'actions/favoriteStation-actions';
import { favoriteTrackToggle } from 'actions/favoriteTrack-actions';
import { favoriteClipToggle } from 'actions/favoriteClip-actions';

import CONTENT_TYPES from 'globalConst/contentTypes-const';
import noop from 'util/noop';

import ToggleFavoriteButton from './ToggleFavoriteButton';

/**
 * NOTE Can be moved to actions folder as soon as station and track toggle are
 * refactored to make use of this ToggleFavorite
 */
const toggleFavorite = (item) => (dispatch) => {
  const { contentTypeId } = item;
  let toggle = noop;

  if (contentTypeId === CONTENT_TYPES.PODCAST) toggle = favoritePodcastToggle;
  if (contentTypeId === CONTENT_TYPES.CLIP) toggle = favoriteClipToggle;
  if (contentTypeId === CONTENT_TYPES.STATION) toggle = favoriteStationToggle;
  if (contentTypeId === CONTENT_TYPES.TRACK) toggle = favoriteTrackToggle;

  dispatch(toggle(item));
};

const mapStateToProps = (state, ownProps) => ({
  isFavorite: getIsFavorite(state, ownProps),
});

const mapDispatchToProps = {
  toggleFavorite,
};

export default connect(mapStateToProps, mapDispatchToProps, null)(ToggleFavoriteButton);
